import type { RumEvent } from '@datadog/browser-rum';
import extractHostnames from './extractHostnames';
import isBlockedDomain from './isBlockedDomain';

const beforeSend = (event: RumEvent): boolean => {
  if (event.type === 'error') {
    if (event.error.message.includes('Script error')) {
      return false;
    }

    if (event.error.resource?.url) {
      try {
        const { hostname } = new URL(event.error.resource.url);
        if (isBlockedDomain(hostname)) {
          return false;
        }
      } catch {
        // invalid resource URL, fall through to message check
      }
    }

    const hostnames = extractHostnames(event.error.message);
    if (hostnames.some(isBlockedDomain)) {
      return false;
    }
  }

  return true;
};

export default beforeSend;
